import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "switch", "options", "schedule"]

  initialize () {
    let _this = this;

    if (_this.hasSwitchTarget) {
      _this.switchTarget.addEventListener('change', function() {
        _this.updateOptions();
      });
    }

    if (_this.hasScheduleTarget) {
      _this.scheduleTarget.addEventListener('click', function() {
        _this.scheduleTarget.style.display = "block";
        _this.optionsTarget.style.display = "block";
        _this.optionsTarget.querySelector("md-filled-text-field").focus();
      });
    }

  
  }

  updateOptions() {
    let _this = this;

    if (_this.hasOptionsTarget && _this.hasSwitchTarget && _this.hasInputTarget) {

      _this.optionsTarget.style.display = "none"

      if (_this.switchTarget.selected) {
        if (_this.hasScheduleTarget ) {
          _this.scheduleTarget.style.display = "none"
        }

        const date = new Date("0001-01-01").toISOString().slice(0, 16);

        _this.inputTarget.value = date;


      } else {
        
        if (_this.hasScheduleTarget ) {
          _this.scheduleTarget.style.display = "flex"
        }
        _this.inputTarget.value = "";
      }

    }

  }

} 
